











































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import camelcase from 'camelcase';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  // form
  public get rules() {
    return {
      username: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      password: [
        {
          required: this.formState === 'create',
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  public form: any = {};

  // filter
  public orderByColumn: string = null;
  public orderByOrder: string = null;
  public username = '';

  // table
  public currentPage = 1;
  public pageSize = 100;
  public count = 1;

  public formVisible = false;
  public isTableLoading = false;
  public data: any[] = [];

  public mounted() {
    this.init();
  }

  // form
  public async onClickCreate() {
    this.formState = "create";
    this.form = {
      enabled: true,
    };
    this.clearFormValidations();
    this.formVisible = true;
  }

  public async onEditClick(row: any) {
    const form = { ...row };
    delete form.password;
    this.formState = "edit";
    this.form = form;
    this.clearFormValidations();
    this.formVisible = true;
  }

  public async onDeleteClick(row) {
    try {
      await this.$confirm(
        `${this.$t('notify["Are you sure to delete"]')} ${
          row.username
        } ?`,
        this.$t('notify["Warning"]').toString(),
        {
          confirmButtonText: this.$t('global["OK"]').toString(),
          cancelButtonText: this.$t('global["Cancel"]').toString(),
          type: "warning"
        }
      );
    } catch (e) {
      console.log(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.deleteAccounts(row.id);
      deleteNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadAccounts();
  }

  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === "create") {
      this.onCreateConfirm();
    } else {
      this.onEditConfirm();
    }
  }

  // table event
  public async onPaginationChange() {
    await this.loadAccounts();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadAccounts();
  }

  //
  private async init() {
    await this.loadAccounts();
  }

  private async loadAccounts() {
    this.isTableLoading = true;
    const { data } = await apiClient.accounts({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      username: this.username,
    });
    this.count = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  // events
  private async onCreateConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      const { data } = await apiClient.postAccounts(this.form);
      this.formVisible = false;
      createNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadAccounts();
  }

  private async onEditConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.putAccounts(this.form.id, this.form);
      this.formVisible = false;
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadAccounts();
  }

  //
  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }

  private validateForm() {
    if (!this.form.username) {
      notifyErrorThrow.bind(this)("missing username");
    }

    if (this.formState === "create") {
      if (!this.form.password) {
        notifyErrorThrow.bind(this)("missing password");
      }
    }
  }
}
